module.exports = __webpack_public_path__ + "static/media/1_A1_12.27f82e57.png";